<iui-messages #messages class="ms-auto me-auto"></iui-messages>
<p-table #tt id="tt" *ngIf="clearSearchIcon" styleClass="p-datatable-striped" [value]="orderList" dataKey="orderId" [paginator]="true" [rows]="100" sortMode="single" sortField="orderId" [sortOrder]="1" [alwaysShowPaginator]="false"
  currentPageReportTemplate="(Displaying {first} to {last} of {totalRecords})" [showCurrentPageReport]="true" [globalFilterFields]="['orderId']"
  [scrollable]="true" scrollHeight="50vh">
  <!-- Template paginatorright as a hacky way to add spacing. DO NOT REMOVE!!! -->
  <ng-template pTemplate="paginatorright" let-state></ng-template>
  <ng-template pTemplate="caption">
    <div class="row">
      <div class="col-4">
        <form class="search-bar-form" style="width: 100%;">
          <input *ngIf="checked" appAlphaNumOnly maxlength="6" type="text" class="search-bar-input" [disabled]="searchLockdown" #globalSearch name="globalSearch"
            placeholder="Search Current Orders" [(ngModel)]="searchInput" (input)="customSCFilter($event)">
          <input *ngIf="!checked" appNumericOnly maxlength="20" type="text" class="search-bar-input" #globalSearch [disabled]="searchLockdown" name="globalSearch"
            placeholder="Search Current Orders" [(ngModel)]="searchInput" (input)="tt.filterGlobal($any($event.target).value, 'contains')" pattern=".*[0-9].*">
          <button *ngIf="searchLockdown" class="small-search-bar-button" id="clearSearchIcon" type="submit" (click)="resetBackendSearch()"><i class="fas fa-xmark"></i></button>
        </form>
      </div>
      <div class="col-4 d-flex justify-content-center search-slider-box">
        <span [ngClass]="{'opacity': checked}" class="slider-text me-2">Order ID</span>
        <p-inputSwitch [(ngModel)]="checked" (onChange)="onSlide()" id="SCONSlider"></p-inputSwitch>
        <span [ngClass]="{'opacity': !checked}" class="slider-text ms-2">Short Code</span>
      </div>
      <div class="col-4 d-flex align-items-center">
        <span *ngIf="listApi !== 'needspayment'" class="d-flex align-items-center">
          <button class="btn btn-sm btn-primary" (click)="searchBackend(searchInput)">Search All
            Orders</button>
          <i class="fa fa-circle-info small" style="color: #004381; margin-left: .1em; margin-bottom: 2rem;"
            pTooltip="Order ID must be 7 digits and a Short Code must be at least 5 characters long." appendTo="body" tooltipPosition="top" tooltipStyleClass="toolCardData"></i>
        </span>
      </div>
    </div>
    <div class="row" *ngIf="orderList.length !== 0 && listApi === 'needspayment'">
      <div class="col-auto mt-3 mb-3">
        <button i18n class="btn btn-primary" (click)="payForSelectedOrders()" [disabled]="ordersForCart.length ===0 ||ordersForCart.length ===1" id="payForSelectedOrders">Pay For
          Selected Orders</button>
        <span class="ms-2">({{selectedOrderLeaseCount}} short codes selected in {{ordersForCart.length}} orders. You may select orders containing a maximum of 20 short
          codes.)</span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr class="mt-3">
      <th class="small-column-flex-override"></th>
      <th class="small-column-flex-override" *ngIf="this.listApi === 'needspayment'">Select ({{selectedOrderLeaseCount}})</th>

      <th *ngFor="let col of orderColumns" [ngSwitch]="col.sorting">
        <ng-container *ngSwitchCase="true">
          <div class="d-flex justify-content-start align-items-center" pSortableColumn="{{col.field}}">
            {{col.header}}
            <p-sortIcon field="{{col.field}}"></p-sortIcon>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="d-flex justify-content-start align-items-center">
            {{col.header}}
          </div>

        </ng-container>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td *ngIf="!checked && searchInput !== '' && !searchLockdown" [attr.colspan]="10">No current orders can be
        found for the search criteria entered. Try searching for all orders.</td>
      <td *ngIf="checked && searchInput !== '' && !searchLockdown" [attr.colspan]="10">This short code does not
        have a current order. Try searching all orders.</td>
      <td *ngIf="!checked && searchInput !== '' && searchLockdown" [attr.colspan]="10">No current orders or
        historical orders can be found for the search criteria entered.</td>
      <td *ngIf="checked && searchInput !== '' && searchLockdown" [attr.colspan]="10">No current or historical
        orders found with this short code.</td>
      <td *ngIf="!searchLockdown && listApi === 'default' && searchInput === ''" [attr.colspan]="10">
        No orders were found. Try Searching all orders.
      </td>
      <td *ngIf="!searchLockdown && listApi === 'needspayment'" [attr.colspan]="10">
        There are currently no orders in your account that need payment.
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-order let-rowIndex="rowIndex" let-expanded="expanded">
    <tr [pSelectableRow]="order" [pSelectableRowIndex]="rowIndex">
      <td class="small-column-flex-override">
        <button type="button" pButton pRipple [pRowToggler]="order" class="p-button-text p-button-rounded p-button-plain"
        (click)="expansionShowHide(order)" [icon]="expanded ? 'fas fa-minus' : 'fas fa-plus'">
      </button>
      </td>
      <td *ngIf="eligibleForMultiOrderPayment(order)">
        <p-checkbox [(ngModel)]="order.selected" [binary]="true" (onChange)="addToCart(order)" id="checkbox{{order.orderId}}"> </p-checkbox>
      </td>
      <td *ngIf="(!eligibleForMultiOrderPayment(order))&& listApi !== 'default'"></td>
      <td *ngFor="let col of orderColumns" [ngSwitch]="col.field">
        <ng-container *ngSwitchCase="'paymentDueDate'">
          {{ order[col.field] | date: 'M/d/yyyy' }}
        </ng-container>
        <ng-container *ngSwitchCase="'orderStatus'">
          {{ order[col.field] | orderStatus }} <span *ngIf="!order.active">(Inactive)</span>
        </ng-container>
        <ng-container *ngSwitchCase="'paymentReceivedDate'">
          {{ order[col.field] | date: 'M/d/yyyy' }}
        </ng-container>
        <ng-container *ngSwitchCase="'invoiceDate'">
          {{ order[col.field] | date: 'M/d/yyyy' }}
        </ng-container>
        <ng-container *ngSwitchCase="'totalPrice'">
          {{ order[col.field] | scrMoney }}
        </ng-container>
        <ng-container *ngSwitchCase="'action'">
          <div class="btn-group">
            <button *ngIf="order.orderStatus === 'PaymentDue' || order.orderStatus === 'PaymentOverdue'" class="btn btn-sm btn-primary me-2"
              (click)="viewInvoice(order.orderId)">View/Pay Invoice</button>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ order[col.field] }}
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-order let-rowIndex="rowIndex">
    <tr *ngIf="order.billingFirstName">
      <td [attr.colspan]="orderColumns.length + 1" class="px-5">
        <div class="row col-12">
          <div class="col-3">Billing Contact: {{ order.billingFirstName }} {{ order.billingLastName }}</div>
          <div class="col-3">Email: {{ order.billingEmail }}</div>
          <div class="col-3" *ngIf="order.orderType === 'Prepay' || order.orderType === 'FreeCarrierCode'">
            PO Number: {{ order.poNumber }}
          </div>
          <div class="col-auto">
            <a class="link me-3" *ngIf="order.orderType === 'BilledMonthly' && order.invoiceDocumentId"
              [routerLink]="['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['statement', order.orderId] } }] } }]">
              View Enrollment Statement
            </a>
            <a class="link me-3" *ngIf="(order.orderType === 'Prepay' || order.orderType === 'FreeCarrierCode') && order.invoiceId && order.invoiceDocumentId"
              [routerLink]="['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['invoice', order.orderId] } }] } }]">
              View Invoice
            </a>
            <a class="link me-3" *ngIf="(order.orderType === 'Prepay' || order.orderType === 'FreeCarrierCode')  && order.receiptDocumentId && order.paymentId"
              [routerLink]="['/dashboard',{outlets: {'navbar-tab': ['my-shortcodes', {outlets: {'my-shortcode-tab': ['multiPaymentReceipt', order.paymentId]}}]}}]">
              View Receipt
            </a>
            <a class="link me-3" *ngIf="(order.orderType === 'Prepay' || order.orderType === 'FreeCarrierCode')  && order.receiptDocumentId && !order.paymentId"
              [routerLink]="['/dashboard',{outlets: {'navbar-tab': ['my-shortcodes', {outlets: {'my-shortcode-tab': ['receipt', order.orderId]}}]}}]">
              View Receipt
            </a>
            <a class="link me-3"
              *ngIf="order.leases.length === 1 && order.leases[0].orderSource === 'Transferred' && (order.leases[0].leaseType === 'Prepay' || order.leases[0].leaseType === 'BilledMonthly')"
              (click)="downloadTransferStatement(order.leases[0].scId, order.orderId)">
              Download Transfer Statement
            </a>
          </div>

        </div>
      </td>
    </tr>
    <tr *ngIf="order.billingFirstName" class="mx-2">
      <td [attr.colspan]="orderColumns.length + 1" class="px-5">
        <p-table styleClass="p-datatable-striped" [value]="order.leases" dataKey="scId" sortField="scId" [sortOrder]="1" id="expandedTable" [style]="{'width': '100%;'}">
          <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let expandCol of expandedOrderColumns" pSortableColumn="{{expandCol.field}}" [ngSwitch]="expandCol.sorting">
        <ng-container *ngSwitchCase="true">
          <div class="d-flex justify-content-start align-items-center">
            {{expandCol.header}}
            <p-sortIcon field="{{expandCol.field}}"></p-sortIcon>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{expandCol.header}}
        </ng-container>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-expandedOrder>
    <tr>
      <td *ngFor="let expandCol of expandedOrderColumns" [ngSwitch]="expandCol.field">
        <ng-container *ngSwitchCase="'scId'">
          <a class="link" (click)="viewShortCode(expandedOrder[expandCol.field])" *ngIf="!expandedOrder.nolink">{{
            expandedOrder[expandCol.field] }}</a>
          <span *ngIf="expandedOrder.nolink">{{
            expandedOrder[expandCol.field] }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'parentOrderId'">
          <a class="link" (click)="goToPrevOrder(expandedOrder[expandCol.field])">{{
            expandedOrder[expandCol.field] }}</a>
        </ng-container>
        <ng-container *ngSwitchCase="'endDate'">
          {{ expandedOrder[expandCol.field] | date: 'M/d/yyyy' }}
        </ng-container>
        <ng-container *ngSwitchCase="'startDate'">
          {{ expandedOrder[expandCol.field] | date: 'M/d/yyyy' }}
        </ng-container>
        <ng-container *ngSwitchCase="'scExpirationDate'">
          {{ expandedOrder[expandCol.field] | date: 'M/d/yyyy' }}
        </ng-container>
        <ng-container *ngSwitchCase="'term'">
          {{ expandedOrder[expandCol.field] | termLength: expandedOrder.leaseType }}
        </ng-container>
        <ng-container *ngSwitchCase="'price'">
          {{ expandedOrder[expandCol.field] | currency }}
        </ng-container>
        <ng-container *ngSwitchCase="'leaseStatus'">
          <span [ngStyle]="{'color': expandedOrder.leaseStatus.startsWith('Cancelled') ? '#FF0000' : ''}">{{
            expandedOrder[expandCol.field] | leaseStatus: expandedOrder.statusReason }}</span>
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ expandedOrder[expandCol.field] }}
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>
</td>
</tr>
</ng-template>
</p-table>